
import GuildEdit from "@/views/guild/GuildEdit";
import CancelTransactionReasonAdd from "@/views/cancelTransactionReason/CancelTransactionReasonAdd";
import CancelTransactionReasonList from "@/views/cancelTransactionReason/CancelTransactionReasonList";
import CancelTransactionReasonEdit from "@/views/cancelTransactionReason/CancelTransactionReasonEdit";


const routes = [
 {
    path: '/cancelTransactionReason/Add',
    name: 'cancelTransactionReasonAdd',
    component: CancelTransactionReasonAdd,
    meta:{requiredAuth:true}
  },
 {
    path: '/cancelTransactionReason/List',
    name: 'cancelTransactionReasonList',
    component: CancelTransactionReasonList,
    meta:{requiredAuth:true}
  },
 {
    path: '/cancelTransactionReason/Edit/:id',
    name: 'cancelTransactionReasonEdit',
    component: CancelTransactionReasonEdit,
    meta:{requiredAuth:true}
  },
]

export default routes